import { useEffect, useState } from 'react';
import { useI18n } from 'src/utils/lni18n';
import { CoursePartWithConnectedDTO } from '../domain/GetCoursepartsResponse';

import classes from "../CoursePart.module.scss";


const CoursePartListAndSelect = (props: { items: CoursePartWithConnectedDTO[], itemChosen: (item: CoursePartWithConnectedDTO) => void }) => {

    const { itemChosen } = props;
    const { languageService: t } = useI18n();
    const [searchText, setSearchText] = useState("");
    const [selected, setSelected] = useState<CoursePartWithConnectedDTO>();
    const [filteredItems, setFilteredItems] = useState<CoursePartWithConnectedDTO[]>([]);


    const [items] = useState([...props.items].sort((a, b) => {
        const nameA = a.Name.toUpperCase();
        const nameB = b.Name.toUpperCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    }));

    useEffect(() => {
        if (searchText && searchText.length > 1) {
            const reg = new RegExp(`${searchText}.*`, "i");
            setFilteredItems(items.filter(p => reg.test(p.Name)));
        }
        else {
            setFilteredItems(items);
        }


    }, [searchText, items]);






    return <>
        <div className='d-flex align-items-center'>
            <input value={searchText} type="text" onChange={(e) => setSearchText(e.currentTarget.value)} placeholder={t.getText("find")} className="input form-control" />
            <button onClick={() => itemChosen(selected!)} className='ml-5 btn btn-primary ms-2' disabled={!selected}>{t.getText("add")}</button>
        </div>
        <div className={`mt-3 ${classes.coursePartList}`} aria-live="polite">
            {filteredItems.map((item) => (
                <button key={item.Id} onClick={() => setSelected(item)} type='button' title={`${t.getText("coursepart")} ${item.Name}`} className={`${selected?.Id == item.Id ? "selected" : ""} px-2 pb-1 text-left btn btn-link`}>
                    {item.Name}
                </button>))}
        </div>
    </>
}


export default CoursePartListAndSelect;